module.exports = __webpack_public_path__ + "static/media/cashback.ce6343b8.svg";